import ConnectSocialInstagram from "./ConnectSocialInstagram";
import ConnectSocialTikTok from "./ConnectSocialTikTok";

const ConnectSocial = {
  TikTok: ConnectSocialTikTok,
  Instagram: ConnectSocialInstagram,
};

export default ConnectSocial;
